module.exports = __webpack_public_path__ + "assets/start-moderation_icon.5e9e671f.svg";